import { render, staticRenderFns } from "./PreServiceBillsTable.vue?vue&type=template&id=5dfd1862&"
import script from "./PreServiceBillsTable.vue?vue&type=script&lang=js&"
export * from "./PreServiceBillsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports